import { render } from "./About.vue?vue&type=template&id=57e1410c&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=57e1410c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e1410c"]])

export default __exports__